var $ = require('jquery');
var jQuery = $;
//appointed - sales - agents start
console.log("from common-th");
if (window.location.href.indexOf("fund-calendar") > -1) {
    setTimeout(function () {
        $(".nice-select.ddlStyle").click(function () {
            $(this).toggleClass("open");
        });
        $(".close").click(function () {
            $('#myModal').css('display', 'none');
        });
    }, 2000);
}
$(".section--banks input").on('keyup', function () {
    var searchValue = $(".section--banks input").val();
    //Reset
    $('.agent-sales').show();

    if (searchValue != "") {
        $(".agent-sales").hide();
        $(".agent-sales a:not(:contains('" + searchValue + "')").parent().parent().parent().show();
    }
});
//appointed - sales - agents end


var $regexname = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
$('.subscribe_btn').on('click', function () {
    $('#spEmail').hide();
    $('#spName').hide();
    var location = window.location.href;
    var locat = '';
    if (location.indexOf('?'))
        locat = location.split('?')[0];
    else
        locat = location;

    var email = $("#txtEmail").val();
    //var _lname = $("#txtLastName").val();
    var _fname = $('#txtFirstName').val();
    var $regexname1 = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    var urlss = window.location.origin + "/api/WebApi/subscribe?FirstName=" + _fname + "&Email=" + email;
    console.log(urlss);

    if (email != "" && _fname != "") {
        console.log("DddD");
        if (!$('#txtEmail').val().match($regexname1)) {
            $("#spemail").text("The email format is wrong!");
            $('#spEmail').show();
        }
        else {
            $('#sub-proess').show();
            $("#spemail").text("");
            $('#spEmail').hide();
            setTimeout(function () {
                $.ajax({
                    url: urlss,
                    type: 'POST',
                    dataType: "json",
                    success: function (data) {
                        console.log(data);
                        if (data != undefined && data != null) {
                            if (data == "Thanks for subscribing") {
                                $('.frm-subscribe').addClass('hide');
                                $('.sucess-frm').removeClass('hide');
                                $('#txtFirstName').val("");
                                $("#txtEmail").val("");
                                $('.thxsub').text("ขอบคุณสำหรับการติดตาม");
                            }
                            else if (data == "Exist" || data.indexOf("BadRequest") != -1) {
                                $('.frm-subscribe').addClass('hide');
                                $('#txtFirstName').val("");
                                $("#txtEmail").val("");
                                $('.thxsub').text('อ๊ะ! คุณสมัครเป็นสมาชิก ด้วยอีเมลนี้แล้ว');
                                $('.sucess-frm').removeClass('hide');
                            }
                            else if (data == "resubscribe") {
                                $('.frm-subscribe').addClass('hide');
                                $('#txtFirstName').val("");
                                $("#txtEmail").val("");
                                $('.thxsub').text('Thanks for re-subscribing!');
                                $('.sucess-frm').removeClass('hide');
                            }
                            //else if (data.indexOf("BadRequest") != -1) {

                            //    $('.frm-subscribe').addClass('hide');
                            //    $('#txtFirstName').val("");
                            //    $("#txtEmail").val("");
                            //    $('.thxsub').text('Oops! You are already subscribed/added with this email id.');
                            //    $('.sucess-frm').removeClass('hide');
                            //}
                            //else if (data.toLowerCase().indexOf("internalservererror") > 0) {

                            //    $('.frm-subscribe').addClass('hide');
                            //    $('#txtFirstName').val("");
                            //    $("#txtEmail").val("");
                            //    $('.thxsub').text(data);
                            //    $('.sucess-frm').removeClass('hide');
                            //}
                            //else if (data.toLowerCase().indexOf("Mail already exists") > 0) {
                            //    $('.frm-subscribe').addClass('hide');
                            //    $('#txtFirstName').val("");
                            //    $("#txtEmail").val("");
                            //    $('.thxsub').text(data);
                            //    $('.sucess-frm').removeClass('hide');
                            //}
                            else {
                                console.log(data);
                            }
                        }

                        $('#sub-proess').hide();
                    },
                    failure: function (response) {
                        $('#sub-proess').hide();
                        console.log("Failed");
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        $('#sub-proess').hide();
                        console.log(thrownError);
                    }
                });
            }, 3000);
        }
    }
    else {
        if (email == "") {
            $('#spEmail').show();
        }
        if (_fname == "") {
            $('#spName').show();
        }
    }
});
$('#txtEmail').on('keypress keydown keyup', function () {
    if (!$(this).val().match($regexname)) {
        console.log("assss");
        // there is a mismatch, hence show the error message
        $("#spemail").text("The email format is wrong!");
        $('#spEmail').show();
    }
    else {
        $("#spemail").text("");
        $('#spEmail').hide();
    }
});

$(document).ready(function () {
    //Chosen Dropdown trigger
    $("#ddlHotFunds").chosen({
        no_results_text: "ไม่พบข้อมูล (No results match)",
        search_contains: true
    });
    $(".ddlHotFunds").change(function () {
        var redirectUrl = $('#ddlHotFunds :selected').val();
        if (redirectUrl != "") {
            var encodedUrl = encodeURI(redirectUrl);
            encodedUrl = encodedUrl.replace('#', '%23');
            encodedUrl = encodedUrl.replace(',', '%2C');
            encodedUrl = encodedUrl.replace('/', '%2F');
            encodedUrl = encodedUrl.replace('?', '%3F');
            encodedUrl = encodedUrl.replace('@@', '%40');
            encodedUrl = encodedUrl.replace('&', '%26');
            encodedUrl = encodedUrl.replace('=', '%3D');
            encodedUrl = encodedUrl.replace('+', '%2B');
            encodedUrl = encodedUrl.replace('$', '%24');
            encodedUrl = encodedUrl.replace('$', '%24');
            if (encodedUrl == 'T05') {
                window.location.href = '/funds/tmb-eastspring-property-and-infrastructure-income-plus-flexible?fundcode=' + encodedUrl;
            }
            else if (encodedUrl == 'I18') {
                window.location.href = '/funds/thai-soldiers-japan-active-equity?fundcode=' + encodedUrl;
            }
            else if (encodedUrl == 'TMB-T-ES-IPlus') {
                window.location.href = '/funds/tmb-thanachart-eastspring-income-plus-fund?fundcode=' + encodedUrl;
            }
            else {
                window.location.href = "/funds/mutual-funds/funddetails?fundcode=" + encodedUrl;
            }
        }
    });
})

$(document).ready(function () {

    var selectedLists = $('#selected-fund-lists');
    setTimeout(function () {
        $(".child-element-annoucement").click(function () {
            var text = $(this).text();
            $(this).text(text == "ปิด" ? "ข้อมูลเพิ่มเติม" : "ปิด");
        });
        //console.clear();
    }, 1000);

    $(window).ready(function () {
        selectedLists.hide();
        var totalItems = $('.notice-total-count').attr("value");
        var takeItems = $('.notice-take-count').attr("value");
        var skipItems = $('.notice-skip-count').attr("value");
        var searchQuery = "";
        var isload = true;
        var searchArrString = [];
        var sourceArr = [];
        var footerheight = $(".footer--wrap").height();
        var selectedList = $('#selected-fund-lists');
        selectedList.on('click', 'a.tag-remove', function (e) {
            e.preventDefault();
            var filtervalue = $(this).attr("filter-value");
            $(this).parent('span.btn--rounded-light-gold').remove();
            $(".only-first-level").each(function () {
                var datatext = $(this).attr("data-text");
                if (datatext == filtervalue) {
                    $(this)[0].click();
                }
            });
            var filteredtaglistcount = $(".filter-tag-lists .btn--rounded-light-gold").length;
            if (filteredtaglistcount == 0) {
                $("#selected-fund-lists").hide();
                $(".tab-pane").hide();
            }
        });
        $("#clear-all-filters-kr").click(function () {
            $(".btn--rounded-gold").removeClass("active");
            $("#selected-fund-lists").hide();
            $(".filter-tag-lists").html('');
            searchArrString = [];
            sourceArr = [];
            searchQuery = '';
            $(".tab-pane").hide();
            FilteredNotice(searchQuery, searchArrString, 100, 0, sourceArr);
        })
        if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
            footerheight = footerheight / 2;
        }
        /*   filter highligting js end*/
        if (window.location.href.indexOf("/fund-announcements") > -1 || window.location.href.indexOf("payment") > -1) {
            window.onscroll = function (ev) {
                if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - footerheight) {
                    totalItems = $('.notice-total-count').attr("value");
                    takeItems = $('.notice-take-count').attr("value");
                    skipItems = $('.notice-skip-count').attr("value");
                    if (isload && parseInt(totalItems) > 10) {
                        isload = false;
                        takeItems = 100;
                        if (skipItems == 0) {
                            skipItems = 100;
                        }
                        if (parseInt(totalItems) > 100) {
                            LoadMoreNotice(searchQuery, searchArrString, takeItems, skipItems, sourceArr);
                        }

                    }

                    // you're at the bottom of the page
                }
            };

            function LoadMoreNotice(SearchText, Categories, take, skip, source) {
                $('#loadtop').show();
                var token = $('input[name="__RequestVerificationToken"]').val();
                var insightsFilterURL = window.location.pathname + "/LoadMoreItems";
                $.ajax({
                    type: "POST",
                    cache: false,
                    dataType: "html",
                    url: insightsFilterURL,
                    data: { __RequestVerificationToken: token, Category: Categories, searchText: SearchText, min: skip, max: take, src: source },
                    success: function (response) {
                        console.log(response)
                        if (response.length > 0) {
                            var insightsresult = response;
                            if (insightsresult != null && insightsresult != undefined) {
                                var strtindex = insightsresult.indexOf("<!-- Filter Listing Tab Start -->");
                                var endindex = insightsresult.indexOf("<!-- Filter Listing Tab End -->");
                                var res = insightsresult.substring(strtindex, endindex);
                                $('.notices-list').append(res);
                                $('.notice-take-count').attr("value", take)
                                $('.notice-skip-count').attr("value", parseInt(take) + parseInt(skip))
                                if (totalItems > (parseInt(take) + parseInt(skip))) {
                                    isload = true;
                                }
                                else {
                                    isload = false;
                                }
                            }
                            $('#loadtop').hide();
                            setTimeout(function () {
                                $(".child-element-annoucement").click(function () {
                                    var text = $(this).text();
                                    $(this).text(text == "ปิด" ? "ข้อมูลเพิ่มเติม" : "ปิด");
                                });
                            }, 1000);
                            return true;
                        }
                        else {
                            $('#loadtop').hide();

                        }

                    },
                    failure: function (response) {
                        $('#loadtop').hide();
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        alert(xhr.status);
                        alert(thrownError);
                        $('#loadtop').hide();
                    }
                })
            }
        }

        $(".only-first-level").click(function () {
            var datafilter = $(this).attr("data-filter-tab");
            var _text = $(this).attr('data-text');
            var hasactive = $(this).hasClass("active");
            if (hasactive) {
                $(this).removeClass("active");
                searchArrString = jQuery.grep(searchArrString, function (value) {
                    return value != _text;
                });
                sourceArr = jQuery.grep(sourceArr, function (value) {
                    return value != _text;
                });

                $(".btn--rounded-light-gold").each(function () {
                    var datafiltertab = $(this).attr("data-filter");
                    if (_text == datafiltertab) {
                        $(this).remove();
                    }
                });
                var filteredtaglistcount1 = $(".filter-tag-lists .btn--rounded-light-gold").length;
                if (filteredtaglistcount1 == 0) {
                    $("#selected-fund-lists").hide();
                    $(".tab-pane").hide();
                    $("#second--level-filter").removeClass("secondlevel-active");
                }
                FilteredNotice(searchQuery, searchArrString, 100, 0, sourceArr);
            }
            else {
                $(this).addClass("active");
                var hasfundtab = $(this).hasClass("fund-tab");
                if (hasfundtab) {
                    $(".tab-pane").hide();
                    sourceArr.push(_text);
                    FilteredNotice(searchQuery, searchArrString, 100, 0, sourceArr);
                    var firstTagStr = _text;
                    $('span.filter-tag-lists', selectedLists).append('<span class="btn--rounded-light-gold first-level" data-filter="' + firstTagStr + '">' + firstTagStr + '<a class="tag-remove" filter-value="' + firstTagStr + '" href="#">x</a></span>');
                    selectedLists.show();
                }
                else {
                    $(".tab-pane").hide();
                    searchArrString.push(_text);
                    FilteredNotice(searchQuery, searchArrString, 100, 0, sourceArr);
                    var firstTagStr = _text;
                    $('span.filter-tag-lists', selectedLists).append('<span class="btn--rounded-light-gold first-level" data-filter="' + firstTagStr + '">' + firstTagStr + '<a class="tag-remove" filter-value="' + firstTagStr + '" href="#">x</a></span>');
                    selectedLists.show();
                }
            }
        });


        $("#notices-filter").keypress(function (e) {
            var key = e.which;
            if (key == 13)  // the enter key code
            {
                searchQuery = $(this).val();
                var encodetext = encodeURIComponent(searchQuery.replace(/%20/g, " "));
                var decodetext = decodeURIComponent(decodeURIComponent(encodetext));
                searchQuery = decodetext;
                $("#notices-filter").val(searchQuery);
                FilteredNotice(searchQuery, searchArrString, 100, 0, sourceArr);
            }
        });
        function FilteredNotice(SearchText, Categories, take, skip, source) {
            $('#loadtop').show();
            var token = $('input[name="__RequestVerificationToken"]').val();
            var insightsFilterURL = window.location.pathname + "/FilteredItems";
            $.ajax({
                type: "POST",
                cache: false,
                dataType: "html",
                url: insightsFilterURL,
                data: { __RequestVerificationToken: token, Category: Categories, searchText: SearchText, min: skip, max: take, src: source },
                success: function (response) {
                    if (response.length > 0) {
                        var insightsresult = response;
                        if (insightsresult != null && insightsresult != undefined) {
                            var strtindex = insightsresult.indexOf("<!-- Filter Listing Tab Start -->");
                            var endindex = insightsresult.indexOf("<!-- Filter Listing Tab End -->");
                            var res = insightsresult.substring(strtindex, endindex);
                            $('.notices-list').html('');
                            $('.notices-list').html(res);
                            $('.notice-take-count').attr("value", take)
                            $('.notice-skip-count').attr("value", parseInt(take) + parseInt(skip))
                            if (totalItems > (parseInt(take) + parseInt(skip))) {
                                isload = true;
                            }
                            else {
                                isload = false;
                            }
                        }
                        $('#loadtop').hide();
                        setTimeout(function () {
                            $(".child-element-annoucement").click(function () {
                                var text = $(this).text();
                                $(this).text(text == "ปิด" ? "ข้อมูลเพิ่มเติม" : "ปิด");
                            });
                        }, 1000);
                        return true;
                    }
                    else {
                        $('#loadtop').hide();

                    }

                },
                failure: function (response) {
                    $('#loadtop').hide();
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    alert(xhr.status);
                    alert(thrownError);
                    $('#loadtop').hide();
                }
            })
        }
    });
});

// how to inest with us 
if (window.location.href.indexOf('funddetails') > -1) {
    $("#howtoinvestwithus-btn").on("click", function () {
        Submit();
    });
    $(document).ready(function () {
        $(".tab-item a").on("click", function () {
            $(".tab-item").removeClass("active");
            $(this).parent().addClass("active");
            $(".tab-item-content").removeClass("active");
            var target = $(this).attr("data-target");
            $(target).addClass("active");
        });
    });
    function initMap() {
        var lattitude = document.getElementById("hdnlattitude").getAttribute("data-content");//$("#hdnlattitude").attr('data-content');
        var longitude = document.getElementById("hdnlattitude").getAttribute("data-bind");// $("#hdnlattitude").attr('data-bind');
        console.log('lattitude', lattitude);
        console.log('longitude', longitude);
        lattitude = parseFloat(lattitude);
        longitude = parseFloat(longitude);
        var thailand = { lat: lattitude, lng: longitude };
        var map = new google.maps.Map(
            document.getElementById('map'), { zoom: 4, center: thailand });
        var marker = new google.maps.Marker({ position: thailand, map: map });
    }

    $(window).load(function () {

        //function initMap() {
        //    var lattitude = $("#hdnlattitude").attr('data-content');
        //    var longitude = $("#hdnlattitude").attr('data-bind');
        //    alert(lattitude, longitude);
        //    var thailand = { lat: lattitude, lng: longitude };
        //    var map = new google.maps.Map(
        //    document.getElementById('map'), { zoom: 4, center: thailand });
        //    var marker = new google.maps.Marker({ position: thailand, map: map });
        //}
        var valCount = 0
        var $regphonenumber = /^[0-9]*$/;
        var $regCellphonenumber = /^([0-9]|#|\-)+$/;

        $('#txtContactNumber').on('keypress keydown keyup', function () {
            if (!$(this).val().match($regCellphonenumber)) {
                // there is a mismatch, hence show the error message
                valCount = 0;
                $("#spContactCallback").text("รูปแบบของโทรศัพท์ติดต่อกลับผิด!");
            }
            else {
                // else, do not display message
                valCount = valCount + 1;
                $("#spContactCallback").text("");
            }
        });

        var $regexname = /^([\w-\.]+)@@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        $('.Howto-invest-txtEmail').on('keypress keydown keyup', function () {
            if (!$(this).val().match($regexname)) {
                // there is a mismatch, hence show the error message
                $("#spemail").text("รูปแบบอีเมลไม่ถูกต้อง!");
                valCount = 0;
            }
            else {
                // else, do not display message
                valCount = valCount + 1;
                $("#spemail").text("");
            }
        });
    });
    $(function () {
        $('.textfield').not('.Howto-invest-txtEmail').on('keypress', function (event) {
            var text = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            validateInput(text);
        });

        $('.textfield').on('paste', function (event) {
            var text = event.originalEvent.clipboardData.getData('text');
            validateInput(text);
        });
    });
    function Validate_Sign_Cantact_Complete() {
        var FirstName = $(".Howto-invest-txtFirstName").val();//$("#txtFirstName").val();
        var LastName = $(".Howto-invest-txtLastName").val();//$("#txtLastName").val();
        var callback = $("#txtContactNumber").val();
        var email = $(".Howto-invest-txtEmail").val();
        var $regCellphonenumber = /^([0-9]|#|\-)+$/;

        var $regexname = /^[a-zA-Z0-9_.]+@([a-zA-Z]{3,6})+.[a-zA-Z.]{2,6}$/;
        var valCount = 0;
        if (FirstName == '' || FirstName == null) {
            valCount = 0;
            $("#spFirstName").text("ชื่อจริงเป็นฟิลด์บังคับ");
            return false;
        }
        else
            valCount = valCount + 1;
        $("#spFirstName").text("");

        if (LastName == '' || LastName == null) {
            valCount = 0;
            $("#spLastName").text("นามสกุลเป็นฟิลด์บังคับ");
            return false;
        }
        else
            valCount = valCount + 1;
        $("#spLastName").text("");
        var target = $("#firstbottom-five-tab").find('.active a').html(); //.closest('a').attr('data-target');
        if (target == "โทรกลับหาฉัน") {
            if (callback == '' || callback == null) {
                valCount = 0;
                $("#spContactCallback").text("โทรศัพท์ติดต่อกลับเป็นฟิลด์บังคับ");
                return false;
            }
            else {
                valCount = valCount + 1;
                $("#spContactCallback").text("");
                $(".Howto-invest-txtEmail").val("-");
            }

            if (!callback.match($regCellphonenumber)) {
                // there is a mismatch, hence show the error message
                $("#spCellphonenumber").text("รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง!");
                return false;
            }
            else {
                // else, do not display message
                $("#spCellphonenumber").text("");
                $(".Howto-invest-txtEmail").val("-");
            }
            if (grecaptcha.getResponse().length == 0) {
                alert('Oops, you have to check the recaptcha !');
                return false;
            }

        }
        else {
            if (email == '' || email == null) {
                $("#spemail").text("ต้องระบุอีเมล");
                return false;
            }
            else {
                valCount = valCount + 1;
                $("#spemail").text("");
                $("#txtContactNumber").val('-');
            }

            if (!email.match($regexname)) {
                // there is a mismatch, hence show the error message
                $("#spemail").text("ข้อผิดพลาดของรูปแบบอีเมล!");
                return false;
            }
            else {
                // else, do not display message
                valCount = valCount + 1;
                $("#spemail").text("");
                $("#txtContactNumber").val('-');
            }
            if (grecaptcha.getResponse().length == 0) {
                alert('Oops, you have to check the recaptcha !');
                return false;
            }
        }
        return true;
    }

    function Submit() {
        if (Validate_Sign_Cantact_Complete()) {
            var subject = "";
            if ($('.fund-listings-tab.bottom-tab-main .section--hdr .second-hdr-underline').length == 1) {
                subject = $('.fund-listings-tab.bottom-tab-main .section--hdr .second-hdr-underline').html();
            }
            else {
                var len = $('.fund-listings-tab.bottom-tab-main .section--hdr .second-hdr-underline').length;
                subject = $('.fund-listings-tab.bottom-tab-main .section--hdr .second-hdr-underline').eq(len).html();
            }
            var FirstName = $(".Howto-invest-txtFirstName").val(); //$("#txtFirstName").val();
            var LastName = $(".Howto-invest-txtLastName").val();//$("#txtLastName").val();
            var callback = $("#txtContactNumber").val();
            var email = $(".Howto-invest-txtEmail").val();
            var terms1 = $('#checkAgree1').is(':checked');
            var terms2 = $('#checkAgree2').is(':checked');
            if (terms1 == true || terms2 == true) {
                var token = $('input[name="__RequestVerificationToken"]').val();
                $.ajax({
                    type: 'post',
                    url: '/home/HowToInvest',
                    data: { __RequestVerificationToken: token, FirstName: FirstName, LastName: LastName, callphonenumber: callback, email: email, subject: subject },
                    //contentType: 'application/json; charset=utf-8',
                    dataType: "json",
                    cache: false,
                    success: function (data) {
                        if (data == "Success") {
                            GTMTagCustomClick('ติดต่อสอบถาม ', '', 'ต้องการให้ติดต่อกลับ');
                            $(".Howto-invest-txtFirstName").val('');
                            $(".Howto-invest-txtLastName").val('');
                            $("#txtContactNumber").val('');
                            $(".Howto-invest-txtEmail").val('');
                            $("#checkAgree1").prop("checked", false);
                            $("#checkAgree2").prop("checked", false);
                            alert('Submitted successfully');
                            grecaptcha.reset();
                        }
                        else
                            alert("เกิดข้อผิดพลาดโปรดลองอีกครั้ง")
                    },
                    failure: function (response) {
                        alert("Failed " + response.responseText);
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        alert(xhr.status);
                        alert(thrownError);
                    }
                });
            }
            else {
                alert("Please select terms and conditions")
            }
            return true;
        }
        else
            return false;
    }
    $(function () {
        $('input[name="txtSearch"]').on('keypress', function (event) {
            var text = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            validateInput(text);
        });

        $('input[name="txtSearch"]').on('paste', function (event) {
            var text = event.originalEvent.clipboardData.getData('text');
            validateInput(text);
        });

        $('.textfield').on('keypress', function (event) {
            var text = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            validateInput(text);
        });

        $('.textfield').on('paste', function (event) {
            var text = event.originalEvent.clipboardData.getData('text');
            validateInput(text);
        });

    });
}

$(document).ready(function () {
    //nice select dropdown start
    /*  jQuery Nice Select - v1.0 */
    !function (e) { e.fn.niceSelect = function (t) { function s(t) { t.after(e("<div></div>").addClass("nice-select").addClass(t.attr("class") || "").addClass(t.attr("disabled") ? "disabled" : "").attr("tabindex", t.attr("disabled") ? null : "0").html('<span class="current"></span><ul class="list"></ul>')); var s = t.next(), n = t.find("option"), i = t.find("option:selected"); s.find(".current").html(i.data("display") || i.text()), n.each(function (t) { var n = e(this), i = n.data("display"); s.find("ul").append(e("<li></li>").attr("data-value", n.val()).attr("data-display", i || null).addClass("option" + (n.is(":selected") ? " selected" : "") + (n.is(":disabled") ? " disabled" : "")).html(n.text())) }) } if ("string" == typeof t) return "update" == t ? this.each(function () { var t = e(this), n = e(this).next(".nice-select"), i = n.hasClass("open"); n.length && (n.remove(), s(t), i && t.next().trigger("click")) }) : "destroy" == t ? (this.each(function () { var t = e(this), s = e(this).next(".nice-select"); s.length && (s.remove(), t.css("display", "")) }), 0 == e(".nice-select").length && e(document).off(".nice_select")) : console.log('Method "' + t + '" does not exist.'), this; this.hide(), this.each(function () { var t = e(this); t.next().hasClass("nice-select") || s(t) }), e(document).off(".nice_select"), e(document).on("click.nice_select", ".nice-select", function (t) { var s = e(this); e(".nice-select").not(s).removeClass("open"), s.toggleClass("open"), s.hasClass("open") ? (s.find(".option"), s.find(".focus").removeClass("focus"), s.find(".selected").addClass("focus")) : s.focus() }), e(document).on("click.nice_select", function (t) { 0 === e(t.target).closest(".nice-select").length && e(".nice-select").removeClass("open").find(".option") }), e(document).on("click.nice_select", ".nice-select .option:not(.disabled)", function (t) { var s = e(this), n = s.closest(".nice-select"); n.find(".selected").removeClass("selected"), s.addClass("selected"); var i = s.data("display") || s.text(); n.find(".current").text(i), n.prev("select").val(s.data("value")).trigger("change") }), e(document).on("keydown.nice_select", ".nice-select", function (t) { var s = e(this), n = e(s.find(".focus") || s.find(".list .option.selected")); if (32 == t.keyCode || 13 == t.keyCode) return s.hasClass("open") ? n.trigger("click") : s.trigger("click"), !1; if (40 == t.keyCode) { if (s.hasClass("open")) { var i = n.nextAll(".option:not(.disabled)").first(); i.length > 0 && (s.find(".focus").removeClass("focus"), i.addClass("focus")) } else s.trigger("click"); return !1 } if (38 == t.keyCode) { if (s.hasClass("open")) { var l = n.prevAll(".option:not(.disabled)").first(); l.length > 0 && (s.find(".focus").removeClass("focus"), l.addClass("focus")) } else s.trigger("click"); return !1 } if (27 == t.keyCode) s.hasClass("open") && s.trigger("click"); else if (9 == t.keyCode && s.hasClass("open")) return !1 }); var n = document.createElement("a").style; return n.cssText = "pointer-events:auto", "auto" !== n.pointerEvents && e("html").addClass("no-csspointerevents"), this } }(jQuery);
    //nice select end
    $('select').not('.ddlHotFunds').niceSelect();
});

/*** provident-funds js start */
if (window.location.href.indexOf("provident-funds") > -1 || window.location.href.indexOf("invest-with-us") > -1) {
    $(document).ready(function () {
        $(".tab-item-pf-1 a").click(function () {
            $(".tab-item-pf-2, #tab-within-tabs-secound-tab-1").removeClass("active");
            $(".tab-item-pf-1, #tab-within-tabs-first-tab-1").addClass("active");
        });
        $(".tab-item-pf-2 a").click(function () {
            $(".tab-item-pf-1, #tab-within-tabs-first-tab-1").removeClass("active");
            $(".tab-item-pf-2, #tab-within-tabs-secound-tab-1").addClass("active");
        })
    });
    $(document).ready(function () {

        var valCount = 0
        var $regphonenumber = /^[0-9]*$/;
        var $regCellphonenumber = /^([0-9]|#|\-)+$/;

        $('#txtContactNumber').on('keypress keydown keyup', function () {
            if (!$(this).val().match($regCellphonenumber)) {
                // there is a mismatch, hence show the error message
                valCount = 0;
                $("#spContactCallback").text("รูปแบบของโทรศัพท์ติดต่อกลับผิด!");
            }
            else {
                // else, do not display message
                valCount = valCount + 1;
                $("#spContactCallback").text("");
            }
        });

        var $regexname = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        $('.ProvidentForm-txtEmail').on('keypress keydown keyup', function () {
            if (!$(this).val().match($regexname)) {
                // there is a mismatch, hence show the error message
                $("#spemail").text("รูปแบบอีเมลไม่ถูกต้อง!");
                valCount = 0;
            }
            else {
                // else, do not display message
                valCount = valCount + 1;
                $("#spemail").text("");
            }
        });
    });
    $(function () {
        $('.textfield').not('.ProvidentForm-txtEmail').on('keypress', function (event) {
            var text = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            validateInput(text);
        });

        $('.textfield').on('paste', function (event) {
            var text = event.originalEvent.clipboardData.getData('text');
            validateInput(text);
        });
    });
    var targettab = "โทรกลับหาฉัน";
    $(".tab-item a").click(function () {
        targettab = $(this).html();
    })
    function Validate_Sign_Cantact_Complete() {
        var FirstName = $(".ProvidentForm-txtFirstName").val();//$("#txtFirstName").val();
        var LastName = $(".ProvidentForm-txtLastName").val();//$("#txtLastName").val();
        var callback = $("#txtContactNumber").val();
        var email = $(".ProvidentForm-txtEmail").val();
        var $regCellphonenumber = /^([0-9]|#|\-)+$/;

        var $regexname = /^[a-zA-Z0-9_.]+@([a-zA-Z]{3,6})+.[a-zA-Z.]{2,6}$/;
        var valCount = 0;
        if (FirstName == '' || FirstName == null) {
            valCount = 0;
            $("#spFirstName").text("ชื่อจริงเป็นฟิลด์บังคับ");
            return false;
        }
        else
            valCount = valCount + 1;
        $("#spFirstName").text("");

        if (LastName == '' || LastName == null) {
            valCount = 0;
            $("#spLastName").text("นามสกุลเป็นฟิลด์บังคับ");
            return false;
        }
        else
            valCount = valCount + 1;
        $("#spLastName").text("");

        //targettab = $("#firstbottom-five-tab").find('.active a').html(); //.closest('a').attr('data-target');
        if (targettab == "โทรกลับหาฉัน") {
            if (callback == '' || callback == null) {
                valCount = 0;
                $("#spContactCallback").text("โทรศัพท์ติดต่อกลับเป็นฟิลด์บังคับ");
                return false;
            }
            else {
                valCount = valCount + 1;
                $("#spContactCallback").text("");
                $(".ProvidentForm-txtEmail").val("-");
            }

            if (!callback.match($regCellphonenumber)) {
                // there is a mismatch, hence show the error message
                $("#spCellphonenumber").text("รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง!");
                return false;
            }
            else {
                // else, do not display message
                $("#spCellphonenumber").text("");
                $(".ProvidentForm-txtEmail").val("-");
            }
            // if (grecaptcha.getResponse().length == 0) {
            //     alert('Oops, you have to check the recaptcha !');
            //     return false;
            // }

        }
        else {
            if (email == '' || email == null) {
                $("#spemail").text("ต้องระบุอีเมล");
                return false;
            }
            else {
                valCount = valCount + 1;
                $("#spemail").text("");
                $("#txtContactNumber").val('-');
            }

            if (!email.match($regexname)) {
                // there is a mismatch, hence show the error message
                $("#spemail").text("ข้อผิดพลาดของรูปแบบอีเมล!");
                return false;
            }
            else {
                // else, do not display message
                valCount = valCount + 1;
                $("#spemail").text("");
                $("#txtContactNumber").val('-');
            }
            // if (grecaptcha.getResponse().length == 0) {
            //     alert('Oops, you have to check the recaptcha !');
            //     return false;
            // }
        }
        return true;
    }
    $(".provident-funds-submit").click(function () {
        providentFundsSubmit();
    });
    function providentFundsSubmit() {

        if (Validate_Sign_Cantact_Complete()) {
            var subject = "";
            var FirstName = $(".ProvidentForm-txtFirstName").val(); //$("#txtFirstName").val();
            var LastName = $(".ProvidentForm-txtLastName").val();//$("#txtLastName").val();
            var callback = $("#txtContactNumber").val();
            var email = $(".ProvidentForm-txtEmail").val();
            var terms1 = $('#checkAgree1').is(':checked');
            var terms2 = $('#checkAgree2').is(':checked');
            var location = window.location.href;
            var locat = '';
            if (location.indexOf('?'))
                locat = location.split('?')[0];
            else
                locat = location;
            if (window.location.href.indexOf("invest-with-us") > -1) {
                locat = locat + '/HowToInvest';
            }
            else {
                locat = '/invest-with-us/HowToInvest';
            }

            if (terms1 == true || terms2 == true) {
                var token = $('input[name="__RequestVerificationToken"]').val();
                $.ajax({
                    type: 'post',
                    url: locat,
                    data: { __RequestVerificationToken: token, FirstName: FirstName, LastName: LastName, callphonenumber: callback, email: email, subject: subject },
                    //contentType: 'application/json; charset=utf-8',
                    dataType: "json",
                    cache: false,
                    success: function (data) {
                        if (data == "Success") {
                            GTMTagCustomClick('ติดต่อสอบถาม ', '', 'ขอให้โทรกลับ');
                            $(".ProvidentForm-txtFirstName").val('');
                            $(".ProvidentForm-txtLastName").val('');
                            $("#txtContactNumber").val('');
                            $(".ProvidentForm-txtEmail").val('');
                            $("#checkAgree1").prop("checked", false);
                            $("#checkAgree2").prop("checked", false);
                            alert('Submitted successfully');
                            grecaptcha.reset();
                        }
                        else
                            alert("เกิดข้อผิดพลาดโปรดลองอีกครั้ง")
                    },
                    failure: function (response) {
                        alert("Failed " + response.responseText);
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        alert(xhr.status);
                        alert(thrownError);
                    }
                });
            }
            else {
                alert("Please select terms and conditions")
            }
            return true;
        }
        else
            return false;
    }
}


/*** provident-funds js end */

